/*
  MEMORABLXS · CARRITO (lógica del cajón lateral, snippets/mx-cart-drawer.liquid)
  - Cambiar cantidad / quitar, agregar recomendados, código de descuento, nota y ventana de garantía.
  - Kit Coleccionista: se agrega solo con 3 piezas y se quita si bajan de 3 (el descuento automático lo deja en $0).
  - Después de cada cambio vuelve a dibujar el cajón y avisa al tema (contador del carrito) con el evento cart:update.
*/
(function () {
  if (window.__mxCartListo) return;
  window.__mxCartListo = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var syncing = false;

  function box() { return document.querySelector('[data-mxcd]'); }
  function busy(on) { var b = box(); if (b) b.classList.toggle('is-busy', !!on); }
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('en-US'); }

  function post(path, body) {
    return fetch(ROOT + path, { method: 'POST', headers: HEADERS, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  // cart/add.js devuelve solo las piezas agregadas; el carrito completo trae item_count
  function isCart(c) { return !!(c && typeof c.item_count === 'number' && c.items); }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // Kit Coleccionista: con 3 piezas o más va 1 en el carrito; con menos, se quita.
  function syncGift(cart) {
    var b = box();
    var kitHandle = (b && b.getAttribute('data-kit-handle')) || 'kit-coleccionista';
    var kitVariant = b && b.getAttribute('data-kit-variant');
    var pieces = 0, kit = null;
    cart.items.forEach(function (it) {
      if (it.handle === kitHandle) kit = it; else pieces += it.quantity;
    });
    if (pieces >= 3 && !kit && kitVariant) {
      return post('cart/add.js', { items: [{ id: +kitVariant, quantity: 1 }] }).then(getCart, getCart);
    }
    if (kit && (pieces < 3 || kit.quantity !== 1)) {
      return post('cart/change.js', { id: kit.key, quantity: pieces < 3 ? 0 : 1 });
    }
    return Promise.resolve(cart);
  }

  // Vuelve a dibujar el cajón y avisa al tema
  function refresh(cart) {
    var b = box();
    var sid = b && b.getAttribute('data-section-id');
    var url = window.location.pathname.split('?')[0] + '?section_id=' + encodeURIComponent(sid || 'cart-drawer');
    return Promise.all([fetch(url).then(function (r) { return r.text(); }), cart ? Promise.resolve(cart) : getCart()])
      .then(function (res) {
        var sections = {};
        if (sid) sections[sid] = res[0];
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: res[1],
            sourceId: 'mx-cart',
            data: { source: 'cart-items-component', itemCount: res[1].item_count, isIncremental: false, sections: sections, mx: true }
          }
        }));
      });
  }

  function run(promise) {
    busy(true);
    syncing = true;
    return promise
      .then(function (cart) { return isCart(cart) ? cart : getCart(); })
      .then(syncGift)
      .then(function (cart) { return isCart(cart) ? cart : getCart(); })
      .then(refresh)
      .catch(function (e) { console.error(e); return refresh(); })
      .finally(function () { busy(false); syncing = false; });
  }

  // Cambios hechos fuera del cajón (por ejemplo, "Agregar al carrito" de la ficha): revisar el regalo
  document.addEventListener('cart:update', function (e) {
    var d = e.detail && e.detail.data;
    if ((d && d.mx) || syncing) return;
    clearTimeout(window.__mxCartT);
    window.__mxCartT = setTimeout(function () {
      getCart().then(function (cart) {
        var b = box();
        var kitHandle = (b && b.getAttribute('data-kit-handle')) || 'kit-coleccionista';
        var pieces = 0, kit = null;
        cart.items.forEach(function (it) { if (it.handle === kitHandle) kit = it; else pieces += it.quantity; });
        var needs = (pieces >= 3 && !kit) || (kit && (pieces < 3 || kit.quantity !== 1));
        if (needs) run(Promise.resolve(cart));
      });
    }, 250);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target;
    if (!t || !t.closest('[data-mxcd]')) return;

    var q = t.closest('[data-mx-qty]');
    if (q) {
      e.preventDefault();
      run(post('cart/change.js', { id: q.getAttribute('data-mx-qty'), quantity: Math.max(0, +q.getAttribute('data-q')) }));
      return;
    }

    var add = t.closest('[data-mx-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('.mxcd__card');
      var sel = card && card.querySelector('[data-mx-sel]');
      if (!sel || !sel.value) return;
      add.disabled = true;
      run(post('cart/add.js', { items: [{ id: +sel.value, quantity: 1 }] }));
      return;
    }

    if (t.closest('[data-mx-code-apply]')) {
      e.preventDefault();
      var input = box().querySelector('[data-mx-code]');
      var code = (input && input.value || '').trim();
      if (!code) return;
      var msg = box().querySelector('[data-mx-code-msg]');
      busy(true);
      getCart().then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) < 0) codes.push(code);
        return post('cart/update.js', { discount: codes.join(',') });
      }).then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
        if (!ok) {
          busy(false);
          if (msg) { msg.textContent = 'Este código no es válido o no aplica a tu carrito.'; msg.hidden = false; }
          // Quitar el código que no aplicó para que no se quede pegado
          var keep = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
          post('cart/update.js', { discount: keep.join(',') });
          return;
        }
        run(Promise.resolve(cart));
      }).catch(function () { busy(false); });
      return;
    }

    var rm = t.closest('[data-mx-code-remove]');
    if (rm) {
      e.preventDefault();
      var drop = rm.getAttribute('data-mx-code-remove').toLowerCase();
      run(getCart().then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c.toLowerCase() !== drop; });
        return post('cart/update.js', { discount: codes.join(',') });
      }));
      return;
    }

    if (t.closest('[data-mx-gar]')) {
      e.preventDefault();
      var g = box().querySelector('[data-mx-garbox]');
      if (g) g.hidden = false;
      return;
    }
    var gb = t.closest('[data-mx-garbox]');
    if (gb && (t === gb || t.closest('[data-mx-gar-close]'))) {
      gb.hidden = true;
    }
  });

  // Precio de la opción elegida en los recomendados (sin texto extra: el precio va dentro de la opción)
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.mxcd [data-mx-sel]');
    if (!sel) return;
    var card = sel.closest('.mxcd__card');
    var add = card && card.querySelector('[data-mx-add]');
    if (add) add.disabled = false;
  });

  // Código con Enter
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('.mxcd [data-mx-code]')) {
      e.preventDefault();
      var b = box().querySelector('[data-mx-code-apply]');
      if (b) b.click();
    }
    if (e.key === 'Escape') {
      var g = document.querySelector('.mxcd [data-mx-garbox]:not([hidden])');
      if (g) { g.hidden = true; e.stopPropagation(); }
    }
  }, true);

  // Nota: se guarda sola mientras escriben
  var noteT;
  document.addEventListener('input', function (e) {
    if (!(e.target.matches && e.target.matches('.mxcd [data-mx-note]'))) return;
    clearTimeout(noteT);
    var v = e.target.value;
    noteT = setTimeout(function () { post('cart/update.js', { note: v }); }, 400);
  });
})();
